import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SectionMetroBannerComponent } from './section-metro-banner.component';

@NgModule({
  declarations: [SectionMetroBannerComponent],
  imports: [CommonModule, RouterModule],
  exports: [SectionMetroBannerComponent],
})
export class SectionMetroBannerModule {}
